module.exports = __webpack_public_path__ + "img/qx80-2025.d6423ce2.png";